<template>
  <!-- Title Section -->
  <div class="self-stretch flex flex-col justify-start items-start gap-6" data-testid="modal-window-container">
    <div class="self-stretch flex flex-col justify-start items-center gap-2">
      <div class="self-stretch flex flex-col justify-center items-center gap-1">
        <div v-if="icon" class="mb-7" data-testid="modal-window-icon">
          <img :src="iconUrl" alt="" data-testid="modal-window-icon-image">
        </div>
        <div v-if="title"
          class="self-stretch text-center justify-start text-white text-2xl font-bold font-['Inter'] leading-[30px] capitalize"
          data-testid="modal-window-title">
          {{ title }}
        </div>
        <div v-if="description" class="text-white opacity-75 text-base text-center mt-2"
          data-testid="modal-window-description">
          {{ description }}
        </div>
      </div>
    </div>

    <!-- Content Section -->
    <div class="self-stretch flex flex-col justify-start items-center gap-2" data-testid="modal-window-content">
      <div class="self-stretch flex flex-col justify-start gap-4">
        <div class="text-left text-white text-[16px] font-[500]"></div>
      </div>
    </div>


    <!-- Buttons Section -->
    <div class="self-stretch flex flex-col justify-start items-start gap-3" data-testid="modal-window-buttons">
      <button v-if="primary" @click="commit"
        class="self-stretch px-5 py-2.5 bg-[#6CBFFF] hover:bg-opacity-30 rounded-xl inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
        data-testid="modal-window-primary-button">
        <div class="justify-start text-black text-base font-medium font-['Inter'] leading-normal">
          {{ primaryText }}
        </div>
      </button>
      <button v-if="secondary" @click.prevent="secondaryAction"
        class="self-stretch px-5 py-2.5 bg-[#6CBFFF]/20 hover:bg-[#6CBFFF]/30 rounded-xl backdrop-blur-[10px] inline-flex justify-center items-center gap-2 overflow-hidden transition duration-160 cursor-pointer"
        data-testid="modal-window-secondary-button">
        <div class="justify-start text-[#6CBFFF] text-base font-medium font-['Inter'] leading-normal">
          {{ secondaryText }}
        </div>
      </button>
      <button v-if="cancel" @click.prevent="cancelAction"
        class="text-primary text-center font-medium text-base self-stretch leading-normal mt-2 cursor-pointer"
        data-testid="modal-window-cancel-button">
        {{ cancelText }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ModalWindow',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    icon: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    },
    primary: {
      type: Boolean,
      required: false,
      default: true,
    },
    secondary: {
      type: Boolean,
      required: false,
      default: false,
    },
    cancel: {
      type: Boolean,
      required: false,
      default: false
    },
    primaryText: {
      type: String,
      required: false,
      default: 'common_done'
    },
    secondaryText: {
      type: String,
      required: false,
      default: 'common_ok'
    },
    cancelText: {
      type: String,
      required: false,
      default: 'common_cancel'
    },
  },
  components: {
  },
  data() {
    return {
      status: "",
      statusText: "",
      enabled: false,
    }
  },
  computed: {
    ...mapState('event', ['event']),
    iconUrl() {
      return require('@/assets/icons/sorenson/' + this.icon + '.svg')
    }
  },
  methods: {
    selfClose() {
      this.$emit('closed');
    },
    commit() {
      if (this.enabled !== this.participation_enabled) {
        this.$emit('commit', this.enabled);
      }
      this.selfClose();
    },
    secondaryAction() {
      this.$emit('secondaryAction')
    },
    cancelAction() {
      this.selfClose();
    }
  },
  mounted() {
  },
}
</script>